export default __webpack_public_path__ + "assets/images/other_products_521bfa12b00a249bf24039207d9bf3ab.jpg";